export default `float a,e,v,s;
  vec3 q;
  v=3.;

  
    
  a = 10.0; 
  
  e=s;
  for(int j=0;++j<6;v*=a)
    q=abs(mod(p*v,2.)-1.),
    q=max(q,q.zyx),
    e=max(e,(min(q.y,q.z)-.3)/v);
  return e;
}`